import React, { useState } from 'react';
import { Button } from '@material-ui/core';

export default function HiddenLink({ text, className, ...other }) {
    const [clearText, setClearText] = useState('****')

    return (
        text && (<Button className={className} onMouseOver={() => setClearText(text) } onMouseOut={() => setClearText('****') } color='primary' {...other}>{clearText}</Button>)
    )
}